__turbopack_context__.v({
  "backdrop": "popover-button-module__Ahvahq__backdrop",
  "button": "popover-button-module__Ahvahq__button",
  "chevron": "popover-button-module__Ahvahq__chevron",
  "error": "popover-button-module__Ahvahq__error",
  "label": "popover-button-module__Ahvahq__label",
  "labelError": "popover-button-module__Ahvahq__labelError",
  "menu": "popover-button-module__Ahvahq__menu",
  "message": "popover-button-module__Ahvahq__message",
  "paddingLess": "popover-button-module__Ahvahq__paddingLess",
  "popover": "popover-button-module__Ahvahq__popover" + " " + __turbopack_context__.i(50657)["animateList"],
  "popoverButtons": "popover-button-module__Ahvahq__popoverButtons",
  "wrapper": "popover-button-module__Ahvahq__wrapper",
});
